$(document).ready(function() {
    const $mainBanner = $('.main_banner');

    if ($mainBanner.length) {
        const $stickyHeader = $('#site_header');
        let isMouseOverHeader = false;

        const $logoImg = $stickyHeader.find('.navbar-brand img');
        const $textElements = $stickyHeader.find('.main-menu-lev1 > li > a, .dropdown-lang > a, .wish .number, .cart .number');
        const $svgPaths = $stickyHeader.find('.navbar-right svg path');
        const $hamburgerSpans = $stickyHeader.find('#nav-icon span');

        const logoData = $mainBanner.data('color-logo');
        const logoColorType = (logoData) ? String(logoData).trim() : null;
        
        const headerColor = $mainBanner.data('color-header');

        const updateHeaderState = () => {
            const isAboveBanner = window.pageYOffset <= $mainBanner.height();
            const hasActiveDropdown = $('#site_header .navbar.navbar-default.margin-none').find('.dropdown.open').length > 0;

            if (isAboveBanner && !hasActiveDropdown && !isMouseOverHeader) {
                $stickyHeader.addClass('trasparent');

                if (logoColorType === 'dark') {
                    $logoImg.css('filter', 'none');
                }

                if (headerColor) {
                    $textElements.css('color', headerColor);
                    $svgPaths.css('fill', headerColor);
                    $hamburgerSpans.css('background-color', headerColor);
                }
            } else {
                $stickyHeader.removeClass('trasparent');

                $logoImg.css('filter', '');
                $textElements.css('color', '');
                $svgPaths.css('fill', '');
                $hamburgerSpans.css('background-color', '');
            }
        };

        $stickyHeader.on('mouseenter', function() {
            isMouseOverHeader = true;
            updateHeaderState();
        });

        $stickyHeader.on('mouseleave', function() {
            isMouseOverHeader = false;
            updateHeaderState();
        });

        $(window).on('scroll', updateHeaderState);
        $stickyHeader.on('shown.bs.dropdown hidden.bs.dropdown', updateHeaderState);

        updateHeaderState();
    }
});


$(document).ready(function() {
    const $stickyHeader = $('#site_header');
    const updateHeaderStateTrasparent = () => {
        const hasActiveDropdown = $('#site_header .navbar.navbar-default.margin-none').find('.dropdown.open').length > 0;
        if(hasActiveDropdown){
            $stickyHeader.addClass('hasActiveDropdown');
        }else{
            $stickyHeader.removeClass('hasActiveDropdown');
        }     
    };
    $('#site_header .navbar.navbar-default.margin-none').on('shown.bs.dropdown hidden.bs.dropdown', updateHeaderStateTrasparent);
    updateHeaderStateTrasparent();   
});


// Animated Hamburger Icon, Open and Close navMobile
$('#nav-icon').click(function(e){
	$('#navbar-collapse-categories-mobile').click(); //Element clicked to trigger the below function that will close the menu automatically when a user clicks outside of it
	e.preventDefault();
	e.stopPropagation();
	$(this).toggleClass('open');
	$('.navMobile').toggleClass('open');
	if (document.body.style.overflow === 'hidden') {
		document.body.style.overflow = '';
        $('#site_header').removeClass('hasActiveDropdown');
	} else {
		document.body.style.overflow = 'hidden';
        $('#site_header').addClass('hasActiveDropdown');
	}
});

$('#nav-icon-close').click(function(e){
	e.preventDefault();
	e.stopPropagation();
	$('#nav-icon').removeClass('open');
	$('.navMobile').toggleClass('open');
	document.body.style.overflow = '';
});

$('[data-zg-scrollTo="next"]').click(function(e) {
    e.preventDefault();
    console.log('NEXT');

    const scrollAmount = window.innerHeight; // 100vh
    $('html, body').animate({
        scrollTop: $(window).scrollTop() + scrollAmount
    }, 600); 
});

		

// DROPDOWN CHE SCENDE IN ALTEZZA E NON DI COLPO
$(document).ready(function() {
	$('.menuCnt .dropdown').on('show.bs.dropdown', function(e) {
		$(this).find('.dropdown-menu').first().stop(true, true).slideDown(250);
	});
	$('.menuCnt .dropdown').on('hide.bs.dropdown', function(e) {
		$(this).find('.dropdown-menu').first().stop(true, true).slideUp(100);
	});
});

$(document).ready(function() {
  var searchDropdown = $('.search-dropdown');
  searchDropdown.on('shown.bs.dropdown', function () {
    $(this).find('input[data-zg-role="search-input"]').focus();
  });
});


$(function() {
    setTimeout(function() {
        const $targets = $('.navbar-nav .dropdown:has(a.collapsable-sub-menu)');  
        $targets.each(function() {
            const $dropdownContainer = $(this);
            const $mainToggle = $dropdownContainer.find('> a.dropdown-toggle');        
            $dropdownContainer.addClass('open');
            $mainToggle.attr('aria-expanded', 'true');
            $dropdownContainer.find('.collapse').first().collapse('show');
        });
    }, 150);
});

$(function() {
	$('[data-zg-role="click-search"]').on('click',function(e){
		e.stopPropagation();
		e.preventDefault();
		$('.search-dropdown .dropdown-toggle').trigger('click');	
	});
});



$(document).ready(function() {
  // Impedisce la chiusura del dropdown quando clicchi al suo interno
  $(document).on('click', '.filter-dropdown .dropdown-toggle', function(e) {
    console.log('filter');
    $('.filters-container').addClass('open');
    $('.filter-background').addClass('open');
  });
  
  // Opzionale: Chiudi solo quando clicchi sulla X o fuori dal dropdown
  $(document).on('click', '.filters-container .login-title svg, .filter-bottom .btn-primary, .filter-background', function(e) {
    e.stopPropagation();
    // Chiudi manualmente il dropdown
    $('.filters-container').removeClass('open');
    $('.filter-background').removeClass('open');
    });
});


$(document).ready(function() {
  const STORAGE_KEY = 'productsColsView';

  function applyColsView(colCount) {
    // Aggiorna i pulsanti
    $('.view-category .btn-desktop').removeClass('active');
    $('.view-category .btn-desktop').each(function() {
      if ($(this).text().trim() === colCount) {
        $(this).addClass('active');
      }
    });

    // Rimuovi tutte le classi 'product-cols-*' e aggiungi quella scelta
    $('#products-container')
      .removeClass(function(index, className) {
        return (className.match(/(^|\s)product-cols-\d+/g) || []).join(' ');
      })
      .addClass('product-cols-' + colCount);
  }

  // Al click su un pulsante
  $(document).on('click', '.view-category .btn-desktop', function(e) {
    e.preventDefault();

    const colCount = $(this).text().trim();

    // Applica la visualizzazione
    applyColsView(colCount);

    // Salva in localStorage
    localStorage.setItem(STORAGE_KEY, colCount);
  });

  // All'apertura della pagina: controlla se c'è una preferenza salvata
  const savedCols = localStorage.getItem(STORAGE_KEY);
  if (savedCols) {
    applyColsView(savedCols);
  }
});


$(document).ready(function() {
  const STORAGE_KEY_MOBILE = 'productsColsViewMobile';

  function applyColsViewMobile(colCountMobile) {
    // Aggiorna i pulsanti
    $('.view-category .btn-mobile').removeClass('active');
    $('.view-category .btn-mobile').each(function() {
      if ($(this).text().trim() === colCountMobile) {
        $(this).addClass('active');
      }
    });

    // Rimuovi tutte le classi 'product-cols-*' e aggiungi quella scelta
    $('#products-container')
      .removeClass(function(index, className) {
        return (className.match(/(^|\s)product-cols-mobile-\d+/g) || []).join(' ');
      })
      .addClass('product-cols-mobile-' + colCountMobile);
  }

  // Al click su un pulsante
  $(document).on('click', '.view-category .btn-mobile', function(e) {
    e.preventDefault();

    const colCountMobile = $(this).text().trim();

    // Applica la visualizzazione
    applyColsViewMobile(colCountMobile);

    // Salva in localStorage
    localStorage.setItem(STORAGE_KEY_MOBILE, colCountMobile);
  });

  // All'apertura della pagina: controlla se c'è una preferenza salvata
  const savedColsMobile = localStorage.getItem(STORAGE_KEY_MOBILE);
  if (savedColsMobile) {
    applyColsViewMobile(savedColsMobile);
  }
});


$(document).on('click', '.product-preview .button--hyperion', function(e) {
  e.preventDefault();
  const $article = $(this).closest('article.panel');
  $article.find('.product-options').addClass('open');
});

$(document).on('click', '.product-preview [data-zg-role="close"]', function(e) {
  e.preventDefault();
  const $article = $(this).closest('article.panel');
  $article.find('.product-options').removeClass('open');
});



